import{cloneElement as o}from"react";import{useMenuButton as e}from"./useMenuButton.js";const t=({children:t})=>{const{opened:n,...r}=e(),p="function"==typeof t?t({opened:n}):t;return o(p,r)};export{t as MenuButton};
//# sourceMappingURL=MenuButton.js.map
